module.exports = __webpack_public_path__ + "static/media/citymapper.366604bc.png";